import { grey } from "@mui/material/colors";

const styles = {
  brandCard: {
    width: "100%",
    borderRadius: 2,
    border: `1px solid ${grey[300]}`,
    backgroundColor: "white",
  },
};

export default styles;
